import { render } from "./PreActionResend.vue?vue&type=template&id=2243b48e&scoped=true"
import script from "./PreActionResend.vue?vue&type=script&lang=js"
export * from "./PreActionResend.vue?vue&type=script&lang=js"

import "./PreActionResend.vue?vue&type=style&index=0&id=2243b48e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2243b48e"]])

export default __exports__